import React from 'react';
import LOOKUP from 'constants/lookup';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';

const orderStatus = [
    { value: "0", text: "All" },
    { value: "1", text: "Created" },
    { value: "2", text: "Preparing" },
    { value: "3", text: "Ready" },
    { value: "4", text: "Completed" },
    { value: "6", text: "Cancelled" },
    { value: "7", text: "Sent to Fulfillment" }
];

const orderType = [
    { value: "0", text: "All" },
    { value: "1", text: "Online - Store Pickup" },
    { value: "2", text: "Online - Delivery" },
    { value: "3", text: "Express Checkout" },
    { value: "4", text: "In Store Fulfillment" },
    { value: "5", text: "In Store Pickup" },
    { value: "6", text: "Online - Curbside Pickup" },
    { value: "7", text: "Online - Drive Through Pick up" },
    { value: "8", text: "Online - Shipping" }
]; 


const searchFields = (props) => {
    return (
        <section className="SearchBarContainer">
            <div className="row p-0">
                <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 col-12">
                    <DatePickerInput
                        name={`${props.pageName}beginDate`}
                        floatingLabelText={LOOKUP.report.common.beginDate.label}
                        hintText={LOOKUP.report.common.beginDate.label}
                        fullWidth={true} 
                    />
                </div> 
                <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 col-12">
                    <DatePickerInput
                        name={`${props.pageName}endDate`}
                        floatingLabelText={LOOKUP.report.common.endDate.label}
                        hintText={LOOKUP.report.common.endDate.label}
                        fullWidth={true} 
                    />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 col-12">
                    <TextInput
                        name={`${props.pageName}OrderCode`}
                        className="search-field"
                        label={LOOKUP.menu.admin.orderDetail.labels.onlineOrderCode}
                        floatingLabelText={LOOKUP.menu.admin.orderDetail.labels.onlineOrderCode}
                        hintText={LOOKUP.menu.admin.orderDetail.labels.onlineOrderCode} />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 col-12">
                    <SelectInput name={`${props.pageName}Status`}
                        className="search-field"
                        label={LOOKUP.ecommerce.onlineOrders.orderStatusLabel}
                        floatingLabelText={LOOKUP.ecommerce.onlineOrders.orderStatusLabel}
                        hintText={LOOKUP.ecommerce.onlineOrders.orderStatusLabel}
                        options={orderStatus}
                        defaultValue="0"
                    />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 col-12">
                    <TextInput
                        name={`${props.pageName}Email`}
                        className="search-field"
                        label={LOOKUP.menu.admin.orderDetail.labels.email}
                        floatingLabelText={LOOKUP.menu.admin.orderDetail.labels.email}
                        hintText={LOOKUP.menu.admin.orderDetail.labels.email} />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 col-12">
                    <TextInput
                        name={`${props.pageName}FirstName`}
                        className="search-field"
                        label={LOOKUP.menu.admin.orderDetail.labels.patientFirstName}
                        floatingLabelText={LOOKUP.menu.admin.orderDetail.labels.patientFirstName}
                        hintText={LOOKUP.menu.admin.orderDetail.labels.patientFirstName} />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 col-12">
                    <TextInput
                        name={`${props.pageName}LastName`}
                        className="search-field"
                        label={LOOKUP.menu.admin.orderDetail.labels.patientLastName}
                        floatingLabelText={LOOKUP.menu.admin.orderDetail.labels.patientLastName}
                        hintText={LOOKUP.menu.admin.orderDetail.labels.patientLastName} />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 col-12">
                    <TextInput
                        name={`${props.pageName}Phone`}
                        className="search-field"
                        label={LOOKUP.menu.admin.orderDetail.labels.phone}
                        floatingLabelText={LOOKUP.menu.admin.orderDetail.labels.phone}
                        hintText={LOOKUP.menu.admin.orderDetail.labels.phone} />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 col-12">
                    <SelectInput name={`${props.pageName}Type`}
                        className="search-field"
                        label={LOOKUP.ecommerce.onlineOrders.orderTypeLabel}
                        floatingLabelText={LOOKUP.ecommerce.onlineOrders.orderTypeLabel}
                        hintText={LOOKUP.ecommerce.onlineOrders.orderTypeLabel}
                        options={orderType}
                        defaultValue="0"
                    />
                </div>
                 {/*Buttons*/}
                 <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 text-right search-icon-container">
                    <Button
                        type="IconSearchButton"
                        label={LOOKUP.product.filters.filterButton}
                        onTouchTap={props.search}
                        className="btnNewBrandPOS" />
                </div>
            </div>
        </section>
    );
};


export default searchFields;